export default (obj = {}) => {
  const fd = new FormData()

  Object.keys(obj).forEach((key) => {
    if (Array.isArray(obj[key])) {
      if (obj[key].length === 0 && key === "images") {
        // For delete images in offers
        fd.append("images", "")
      } else {
        obj[key].forEach((item) => {
          fd.append(key, item)
        })
      }
    } else {
      fd.append(key, obj[key])
    }
  })

  return fd
}
